import React, { useEffect, useState } from 'react';
import moment from 'moment';
import 'moment/min/locales';
import axios from '../../../config/axiosInstance';
import { Button, Grid, Typography, Box, Modal, } from '@mui/material';
import BlockIcon from '@mui/icons-material/Block';
import ErrorIcon from '@mui/icons-material/Error';
import { usageLog, } from '../../../store/actions/globalActions';
import { result } from 'lodash';
import AvatarGabi from '../../../assets/images/Avatar-Gabi.png'
import WhatsAppIcon from '@mui/icons-material/WhatsApp';



const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '50em',
    height: '65%',
    bgcolor: '#4651e6',
    boxShadow: 24,
    p: 4,
    borderRadius: '2em',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    color: '#FFFF',
    outline: 'none'
};


const WarningBlocked = (props) => {

    const [dateBloqued, setDateBloqued] = useState('')
    const [isBloquedAccount, setIsBloquedAccount] = useState(false)
    const [isTrial, setIsTrial] = useState(false)
    const [paymentSlip, setPaymentSlip] = useState(null)

    useEffect(() => {
        searchOpenModal();
    }, [])

    async function searchOpenModal() {

        try {

            const response = await axios.get('/warning')
            if (response.data.isBloquedAccount && response.data.isTrial) {
                setIsBloquedAccount(response.data.isBloquedAccount)
            }

        } catch (error) {

        }
    };


    const companyId = JSON.parse(localStorage.companies)

    return (

        <>
            <Modal
                open={isBloquedAccount}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 700,
                        height: 425,
                        // bgcolor: 'background.paper',
                        // boxShadow: 'none',
                        p: 4,
                        backgroundColor: '#4851de',
                        borderRadius: '20px',
                        alignItems: 'center',
                        justifyContent: 'center',
                        outline:'none'
                    }}
                >

                    <img
                        alt="icon"
                        src={AvatarGabi}
                        style={{
                            width: '120px',
                            height: '120px',
                            position: 'absolute',
                            top: '-61px',
                            left: '50%',
                            transform: 'translateX(-50%)'
                        }}
                    />
                    <Typography
                        id="modal-modal-description"
                        sx={{ mt: 2 }}
                        textAlign={'center'}
                        style={{
                            fontWeight: '500',
                            fontFamily: 'Montserrat',
                            color: 'white',
                            marginTop: '17px',
                            fontSize: '30px'
                        }}>
                        {'Olá! Aqui é a Gabi. Tudo bem?'}
                    </Typography>
                    <Typography id="modal-modal-title" variant="h6" component="h2"
                        style={{
                            fontFamily: 'Arial',
                            color: 'blue',
                            backgroundColor: 'white',
                            marginTop: '40px',
                            width: 700,
                            height: 355,
                            marginLeft: '-32px',
                            borderRadius: '20px',
                            textAlign: 'center',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            padding: '10px'
                        }}
                    >
                        <p style={{ fontSize: '30px', color: '#555554', marginTop: '-3px', fontWeight: 'bold', fontFamily: 'Montserrat', marginBottom: '9px' }}>
                            Parabéns 🎉
                        </p>
                        <p style={{ fontSize: '14px', color: '#555455', marginTop: '-3px', fontWeight: 'bold', fontFamily: 'Montserrat', marginBottom: '-3px' }}>
                            Você completou a jornada de teste na nossa plataforma:
                        </p>
                        <p style={{ fontSize: '14px', color: '#555455', marginTop: '-3px', fontFamily: 'Montserrat' }}>
                            registrou sua empresa, cadastrou funcionário e bateu ponto.
                        </p>
                        <p style={{ fontSize: '14px', color: '#555455', marginTop: '3px', fontFamily: 'Montserrat' }}>
                            Elimine de forma definitiva problemas como:
                        </p>
                        <p style={{ fontSize: '14px', color: '#555455', marginTop: '-3px', fontFamily: 'Montserrat' }}>
                            <li style={{ marginBottom: '-3px' }}>Estresse com controle de ponto de funcionários</li>
                            <li style={{ marginBottom: '-3px' }}>Cansativas horas de trabalho com fechamento da folha de ponto</li>
                            <li>Riscos trabalhistas</li>
                        </p>
                        <p style={{ fontSize: '14px', color: '#555455', fontFamily: 'Montserrat', marginBottom: '-22px', marginTop: '-3px' }}>
                            Conte com o Puntu para isso.
                        </p>
                        <p style={{ fontSize: '14px', color: '#555455', fontFamily: 'Montserrat' }}>
                            Aguardo sua mensagem 😄
                        </p>
                        <Button
                            style={{
                                backgroundColor: '#00a000',
                                color: 'white',
                                borderRadius: '20px',
                                width: '480px',
                                height: '50px',
                                display: 'flex',
                                justifyContent: 'space-between',
                                textTransform: 'none',
                                fontSize: '20px',
                                fontWeight: 'bold',
                                padding: '0 50px'
                            }}
                            href={'https://api.whatsapp.com/send?phone=5561991466572&text=Oi,%20quero%20o%20Puntu%20em%20definitivo!'}
                            onClick={() => { usageLog("warning/modal/fimTesteGratis/WhatsApp/Gabriela", companyId[0].companyId, companyId[0].byUser) }}
                        >
                            <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                                Enviar mensagem no WhatsApp
                            </div>
                            <div style={{ marginLeft: '19em', position: 'absolute', marginTop: '10px' }}>
                                <WhatsAppIcon style={{ fontSize: '40px' }} />
                            </div>
                        </Button>

                        <Button
                            href="/logout"
                            style={{
                                color: '#555554',
                                marginTop: '1em',
                                paddingLeft: '2em',
                                paddingRight: '2em',
                                fontWeight: 'bold',
                                fontFamily: 'montserrat',
                                borderRadius: '15px',
                                border: '1px solid #555554',
                                backgroundColor: 'white'
                            }}
                            onClick={() => { usageLog("warning/modal/fimTesteGratis/Sair", companyId[0].companyId, companyId[0].byUser) }}
                        >
                            Sair
                        </Button>


                    </Typography>


                </Box>
            </Modal>


        </>

    );
}


export default WarningBlocked;
